import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/check.svg';
import MerchantReinsurance from '~/components/molecules/Product/MerchantReinsurance.vue';
import ProductMerchants from '~/components/molecules/Product/ProductMerchants.vue';
export default {
  name: 'Reinsurance',
  components: {
    MerchantReinsurance,
    ProductMerchants
  },
  props: {
    deliveryPayload: {
      type: Object,
      required: true
    },
    withMerchant: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      activeDeliveryPayload: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    offers() {
      return {
        total: 2
      };
    },

    merchant() {
      return {
        reference: '102030',
        name: 'Hay',
        score: 3.9,
        reviews: {
          total: 15
        }
      };
    },

    deliveryUrl() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/statique/livraison.htm");
    },

    returnsUrl() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/retour-gratuit.htm");
    }

  }),
  methods: {
    handleClickDelivery(event) {
      this.$root.$emit('generic-tracking', event, {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_FAQ_Livraison',
          event_label: 'Clic_FAQ_Livraison'
        }
      });
    },

    handleClickReturns(event) {
      this.$root.$emit('generic-tracking', event, {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_FAQ_Retours',
          event_label: 'Clic_FAQ_Retours'
        }
      });
    }

  }
};